
<template>
  <div>
    <v-card  flat height="100%" class="d-flex flex-column">
      <v-card-text class="px-0 pb-2 pt-2">
        <v-stepper v-model="stepper_count" class="elevation-0">
          <v-stepper-header class="elevation-0" style="height: 100%;">
            <template  v-for="item, idx in stepper_items">
              <v-stepper-step class="pb-3 pt-3 px-1" :step="idx + 1" :editable="stepper_count > (idx + 1)"> {{ item.title }} <small>{{ item.subtitle }}</small></v-stepper-step>
            </template>
          </v-stepper-header>
          <div class="d-flex justify-center subtitle-1 font-weight-light" v-if="this.$vuetify.breakpoint.smAndDown">
            {{stepper_items[stepper_count -1].title }} {{stepper_items[stepper_count -1].subtitle }} 
          </div>
          <v-divider></v-divider>
          <v-card flat style="overflow-y: auto;">
            <v-card-text class="pa-0">
              <!-- STEP 1 -->
              <v-stepper-content step="1" class="pa-0">
                <v-form ref="form1" v-if="stepper_count >= 1">
                  <SimpleSelectDepot :order="order"></SimpleSelectDepot>
                  
                </v-form>
              </v-stepper-content>
              <!-- FIM STEP 1 -->
              
              <!-- STEP 2 -->
              <v-stepper-content step="2" class="pa-0">
                <v-form ref="form2" v-if="stepper_count >= 2">
                  <v-checkbox v-if="order.kind == 'pickup'" class="mx-4" v-model="order.is_default_client" label="Cliente final" :disabled="!order.modality_id"></v-checkbox>
                  <ClientSelection 
                    v-if="!order.is_default_client" 
                    @canUseClient="handleCanUseClient" 
                    :order="order"
                    :modality_id="order.modality_id"
                    @redo="handleRedoOrder"
                  ></ClientSelection>
                </v-form>
              </v-stepper-content>
              <!-- FIM STEP 2 -->

              <!-- STEP 3 -->
              <v-stepper-content step="3" class="pa-0">
                <v-form ref="form3" v-if="stepper_count >= 3">
                  <SelectSellerAndManager :order="order"></SelectSellerAndManager>
                </v-form>
              </v-stepper-content>
              <!-- FIM STEP 3 -->

              <!-- STEP 4 -->
              <v-stepper-content step="4" class="pa-0">
                <v-form ref="form4" v-if="stepper_count >= 4">
                  <DeliveryKind :order="order" ref="delivery_kind"></DeliveryKind>
                </v-form>
              </v-stepper-content>
              <!-- FIM STEP 4 -->

              <!-- STEP 5 -->
              <v-stepper-content step="5" class="pa-0">
                <v-form ref="form5" v-if="stepper_count >= 5">
                  <ProductAndPrices :order="order" @addItem="handleAddItem"></ProductAndPrices>
                </v-form>
              </v-stepper-content>
              <!-- FIM STEP 5 -->

              <!-- STEP 6 -->
              <v-stepper-content step="6" class="pa-0">
                <v-form ref="form6" v-if="stepper_count >= 6">
                  <ShippingData :order="order"></ShippingData>
                </v-form>
              </v-stepper-content>
              <!-- FIM STEP 6 -->

              <!-- STEP "7 -->
              <v-stepper-content step="7" class="pa-0">
                <v-form ref="form7" v-if="stepper_count >= 7">
                  <EditOrderPayments :order="order" retail ref="order_payments"></EditOrderPayments>
                </v-form>
              </v-stepper-content>
              <!-- FIM STEP "7 -->

              <!-- STEP "8 -->
              <v-stepper-content step="8" class="pa-0">
                <v-form ref="form8" v-if="stepper_count >= 8">
                  <v-alert v-if="!had_limit && stepper_count == 8" color="red" type="error" class="mt-1">
                    Valor total do pedido está acima do limite disponível do cliente. Favor entrar em contato com gerência.
                  </v-alert>
                  <v-alert v-if="!had_bonus_for_anticipated && stepper_count == 8" color="red" type="error" class="mt-1">
                    Prazo Antecipado exige bônus suficiente. O cliente precisa ter o valor do pagamento em bônus para lançar o pedido.
                  </v-alert>
                  <FinishRetailOrder :order="order"></FinishRetailOrder>
                </v-form>
              </v-stepper-content>
              <!-- FIM STEP "8 -->

            </v-card-text>
          </v-card>
        </v-stepper>
        
      </v-card-text>
    </v-card>

    <v-footer app class="white">
      <v-sheet class="d-flex mb-3 justify-center align-center" width="100%">
        <v-divider></v-divider>
      </v-sheet>
      <v-sheet class="d-flex mb-2 justify-center align-center" width="100%">
        <v-btn small :disabled="stepper_count == 1" @click="stepper_count--" class="mx-1 error">
          <v-icon left>mdi-arrow-left-bold-circle</v-icon>
          Anterior
        </v-btn>
        <v-btn v-if="stepper_count < stepper_items.length" :disabled="(stepper_count == 7 ? !same_ammount : false)" small @click="nextStepper" class="mx-1 success">
          Avançar
          <v-icon right>mdi-arrow-right-bold-circle</v-icon>
        </v-btn>

        <v-btn v-if="stepper_count == stepper_items.length" :disabled="!same_ammount || !can_create_order" small @click="createOrder" class="mx-1 success"> 
          <v-icon left>mdi-note-plus</v-icon> Finalizar
        </v-btn>
      </v-sheet>
    </v-footer>

    
    
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>

  </div>
</template>

<script>
import validations from '@/mixins/validations';
import Api from '@/api/index';
import default_address from './shared/DefaultAddress';
import default_payment from './shared/DefaultPayment';
import default_item from './shared/DefaultItem';
import retail_order from './shared/RetailOrder';

export default {
  name: 'CreateRetailOrder',
  mixins: [ validations ],
  components: {
    SelectSellerAndManager:() => import("@/components/create_order/shared/SelectSellerAndManager.vue"),
    ClientSelection: () => import("@/components/create_order/shared/ClientSelection.vue"),
    EditOrderPayments: () => import('@/components/create_order/shared/payments/EditOrderPayments.vue'),
    SimpleSelectDepot: () => import("./Depot/SimpleSelectDepot"),
    ProductAndPrices: () => import('./Products/ProductAndPrices.vue'),
    ShippingData: () => import('./Shipping/ShippingData'),
    DeliveryKind: () => import('./Shipping/DeliveryKind'),
    FinishRetailOrder: () => import('./Conclude/FinishRetailOrder'),
  },
  data() {
    return {
      order:{...retail_order},

      stepper_count: 1,
      confirmation_dialog: false,
      stepper_items: [
        {title: 'Galpão', subtitle: ''},
        {title: 'Cliente', subtitle: ''},
        {title: 'Responsáveis', subtitle: ''},
        {title: 'Infomação', subtitle: 'do pedido'},
        {title: 'Produtos', subtitle: 'e preços'},
        {title: 'Frete', subtitle: 'Responsáveis e valores'},
        {title: 'Pagamentos', subtitle: ''},
        {title: 'Revisão do pedido', subtitle: ''},
      ],
      saving: false,
      can_use_client: true,
      client_last_order: null,
      all_pay_times: [],
    }
  },
  methods: {
    isNewAddress(){
      return this.order?.shipping_attributes?.is_new_address && this.order?.kind == 'delivery'
    },
    setWholeAddressForNewAddress(){
      let {addr, number, zip, city, state, complement, neighborhood} = this.order.new_address_attributes
      this.order.shipping_attributes.whole_address = `${addr}, Nº ${number} ${complement? ', '+complement : ''}, bairro ${neighborhood} ,CEP ${zip}, ${city} - ${state}`
    },
    handleRedoOrder(order){      
      let selected_modality = this.order.modality_id
      
      this.order = {...order, modality_id: selected_modality}

      this.stepper_count = 3
    },
    handleAddItem(){
      this.order.items_attributes.push({...default_item})
    },
    handleCanUseClient(can){
      this.can_use_client = can
    },
    handleRebaseClient(){
      this.order.client_id = null
    },
    setData(){
      this.order.new_address_attributes = {...default_address}

      this.order.items_attributes = [{...default_item}]

      this.order.payments.list = [{...default_payment}]
    },
    nextStepper(){
      let valid_new_address = true
      if(this.stepper_count == 4){
        valid_new_address = this.$refs.delivery_kind.validate()
      }
      let payment_selected = true
      if(this.stepper_count == 7){
        payment_selected = this.$refs.order_payments.validate()
      }

      if(this.$refs[`form${this.stepper_count}`].validate() && valid_new_address && payment_selected){
        this.stepper_count++;
      }else{
        this.missingFields()
      }
    },
    createOrder(){
      this.swallConfirmation({ title: 'Deseja criar pedido?', icon: 'question' }).then( confirmed =>{
        if (confirmed) {
          this.order.client_wants_email = 'dont_want'
          let order = this.prepareOrder()
          this.saving = true
          Api.Order.createRetailOrder(order).then(response => response.data).then(Order => {
            this.addNotification({type: 'success', msg: 'Criado com sucesso!'})
            this.resetBuilding()
            this.$emit('created', { id: Order.id, solution: 'retail' })
          }).catch((error) => {
            this.addNotification({type: 'error', msg: `Erro: ${error}`})
            console.log(error);
          }).finally(()=>{
            this.saving = false
          })
        }
      })
    },
    prepareOrder(){
      if (this.order.kind == 'pickup'){
        this.order.items_attributes = this.order.items_attributes.map(i => { return {...i, is_delivery: false, unit_ship: null, unit_ship_aux: null, total_ship: null, total_ship_aux: null }})
        this.order.shipping_attributes = null
        this.order.order_status = 'to_pickup'
        this.order.new_address_attributes = null
      }else if (this.order.kind == 'delivery'){
        this.order.is_default_client = false
        this.order.order_status = 'to_approve'
      }
      // passando para valor numerico, retirando as virgulas
      this.order.items_attributes = this.order.items_attributes.map(i => {
        return {
          ...i,
          sell_price: i.sell_price_aux.replace(/,/g, ''),
          total_units: i.total_units_aux.replace(/,/g, ''),
          unit_ship: this.order.kind == 'delivery' ? i.unit_ship_aux.replace(/,/g, '') : null,
        }
      })
      if(this.order.shipping_attributes){
        // let shipping_attributes = this.order.shipping_attributes
        // shipping_attributes.shipping_value = shipping_attributes.shipping_value_aux.replace(/,/g, '')
        // if( (!shipping_attributes.building?.id || !shipping_attributes.building_id)  && shipping_attributes.building_attributes){
        //   // Se tem o building attributes
        //   shipping_attributes.building_attributes.client_id = this.order.client_id
        //   shipping_attributes.building_id = null
        // }else if(!shipping_attributes.building_id && shipping_attributes.building?.id){
        //   // Não foi setado ainda a obra no shipping
        //   shipping_attributes.building_id = shipping_attributes.building?.id
        //   shipping_attributes.building_attributes = null
        // }else if(shipping_attributes.building_id){
        //   // Pedido de clonagem, já possui obra
        //   shipping_attributes.building_attributes = null
        // }

        this.order.shipping_attributes.shipping_value = this.order.shipping_attributes.shipping_value_aux.replace(/,/g, '')
        if( !this.order.shipping_attributes.building?.id  && this.order.shipping_attributes.building_attributes){
          this.order.shipping_attributes.building_attributes.client_id = this.order.client_id
          this.order.shipping_attributes.building_id = null
        }else if(!this.order.shipping_attributes.building_id){
          this.order.shipping_attributes.building_id = this.order.shipping_attributes.building?.id
          this.order.shipping_attributes.building_attributes = null
        }
      }

      this.order.total_order_units = this.order.items_attributes.reduce((acc, one) => Number(one.total_units) + acc, 0 )
      this.order.total_order_sell = this.order.items_attributes.reduce((acc, one) => Number(one.total_sell_price) + acc, 0 )

      if (this.order.kind == 'delivery' && !this.order.shipping_attributes?.is_new_address){
        this.order.new_address_attributes = null
      }
      
      this.order.payments.list = this.order.payments.list.map(pay=> {
        let {ammount, ...p} = pay
        ammount = ammount.replace(/,/g, '')
        return {...p, ammount}
      })

      return this.order
    },
    resetBuilding(){
      if(this.order.shipping_attributes){
        this.order.shipping_attributes.building = { id: null }
        this.order.shipping_attributes.building_attributes = {
          address_attributes: {}
        }
      }
    },
    loadPaymentTimes() {
      Api.PaymentOption.index('times').then(r => r.data).then(pay => {
        this.all_pay_times = [...pay.data.map(el => ({ ...el, id: parseInt(el.id) }))]
      }).catch(() => {})
    },
  },
  computed: {
    had_limit(){
      if(this.stepper_count == 8){
        if( this.order.client ){
          let client_limit = this.order.client.credits?.data?.attributes?.limit ? this.order.client?.credits?.data?.attributes?.limit : this.order.client.client_credit?.limit
          let payment_options = this.order.payments.list.filter(el =>![1, 6].includes(el.payment_option_id) && ![3].includes(el.payment_time_id))
          let total_invoice_without_money = payment_options.length == 0 ? 0 : parseFloat(payment_options.map(el=> el.ammount.replace(',', '')).reduce((accumulator, current) => (accumulator) + current)) 
          return parseFloat(client_limit) >= parseFloat(total_invoice_without_money) 
        }else{
          return true
        }
      }
    },
    anticipated_payment_time_ids() {
      return this.all_pay_times
        .filter(time => time.attributes?.anticipated)
        .map(time => parseInt(time.id))
    },
    anticipated_payments_total() {
      if (!this.order.payments?.list?.length || !this.anticipated_payment_time_ids.length) return 0

      return this.order.payments.list
        .filter(el => this.anticipated_payment_time_ids.includes(parseInt(el.payment_time_id)))
        .reduce((acc, el) => acc + parseFloat(String(el.ammount).replace(/,/g, '') || 0), 0)
    },
    client_bonus() {
      const credits = this.order.client?.credits?.data?.attributes
      const client_credit = this.order.client?.client_credit
      return parseFloat(credits?.bonus ?? client_credit?.bonus ?? 0)
    },
    had_bonus_for_anticipated() {
      if (this.stepper_count != 8) return true
      if (this.anticipated_payments_total <= 0) return true
      return this.client_bonus >= this.anticipated_payments_total
    },
    can_create_order() {
      return this.had_limit !== false && this.had_bonus_for_anticipated
    },
    same_ammount(){
      let sell_price = null
      if(this.order.total_order_sell){
        sell_price = this.order.total_order_sell 
      }else{
        sell_price = this.order.items_attributes?.reduce((acc, one) => Number(one.total_sell_price) + acc, 0 )
      }
      let partial = this.order.payments.list.reduce((acc, one) => parseFloat(String(one.ammount).replaceAll(',', ''))+acc, 0)
      if(isNaN(partial)){
        partial = 0
        partial = partial.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      }else{
        partial = partial.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      }
      return Number(sell_price).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) == partial
    },
  },
  mounted () {
    this.setData();
    this.loadPaymentTimes();
  },
  watch: {
    stepper_count(){
      if(this.stepper_count == 6 && this.isNewAddress()){
        this.setWholeAddressForNewAddress()
      }
    },
    'order.is_default_client'(nv,ov) {
      if (nv){
        this.order.client_id = null
        this.order.client_name = null
        this.order.payments.list = [{...this.order.payments.list[0]}]
      }
    },
    // 'order.shipping_attributes.building' (nv) {
    //   if(nv){
    //     this.order.shipping_attributes.building_id = nv.attributes.id
    //   }
    // }
  },
}
</script>